// import { useHistory } from 'react-router-dom';
import { BehaviorSubject } from 'rxjs';
import { apiGet, apiPost } from '../../api/index';
import { urlUsers } from '../../api/urls';

const currentUserSubject = new BehaviorSubject(JSON.parse(localStorage.getItem('currentUser')));
// const history = useHistory();

export const SET_LOGIN_VALUE = 'SET_LOGIN_VALUE';
export const LOGIN_LOADING = 'LOGIN_LOADING';
export const LOGIN_SUCCESS = 'LOGIN_SUCCESS';
export const LOGIN_FAILED = 'LOGIN_FAILED';
export const LOGOUT = 'LOGOUT';
export const CHANGE_USER_VIEW_AS = 'CHANGE_USER_VIEW_AS';

export const loginLoading = () => ({ type: LOGIN_LOADING });
export const loginSuccess = user => ({ type: LOGIN_SUCCESS, payload: user });
export const loginFailed = error => ({ type: LOGIN_FAILED, payload: error });

export const userLoggedOut = () => ({ type: LOGOUT });
export const resetView = () => ({ type: CHANGE_USER_VIEW_AS, value: 0 });

const getLoginData = () => JSON.parse(localStorage.getItem('currentUser')) || {};

const storeUserLogin = (user) => {
  const loginData = { ...user, isAuthenticated: true };
  localStorage.setItem('currentUser', JSON.stringify(loginData));
  currentUserSubject.next(loginData);
  return loginData;
};

export const logout = () => (dispatch) => {
  // Clear the login data
  localStorage.removeItem('currentUser');
  currentUserSubject.next(null);
  dispatch(userLoggedOut());
  dispatch(resetView());
};

export function login(data, callback) {
  return (dispatch) => {
    dispatch(loginLoading());
    apiPost(`${urlUsers}/login`, data)
      .then((response) => {
        if (response.error) {
          throw (response.error);
        }

        storeUserLogin(response);
        if (response.firstLogin && callback && callback.onFirstLogin) {
          callback.onFirstLogin(response);
        } else if (callback && callback.onSuccess) {
          dispatch(loginSuccess(getLoginData()));
          callback.onSuccess(response);
        }
        return response;
      })
      .catch((error) => {
        dispatch(loginFailed(error));
        if (callback && callback.onError) callback.onError(error);
      });
  };
}


export function firstLogin(values, callback) {
  return (dispatch) => {
    dispatch(loginLoading());
    const currentUser = JSON.parse(localStorage.getItem('currentUser')) || {};

    // Prepare data for set_new_password API call
    const data = {
      email: values.email || currentUser.email,
      token: values.token || currentUser.resetToken,
      newPassword: values.newPassword,
      newPasswordConfirmation: values.newPasswordConfirmation, // Current password for non-reset scenarios
    };

    apiPost(`${urlUsers}/set_new_password`, data)
      .then((response) => {
        if (response.error) {
          throw (response.error);
        }
        storeUserLogin(response);
        dispatch(loginSuccess(getLoginData()));
        if (callback && callback.onSuccess) callback.onSuccess(response);
        return response;
      })
      .catch((error) => {
        dispatch(loginFailed(error));
        if (callback && callback.onError) callback.onError(error);
      });
  };
}

export function verifyUserToken(callback) {
  return (dispatch) => {
    // dispatch(loginLoading());
    apiGet(`${urlUsers}/get_login_status`)
      .then((response) => {
        if (response.error) {
          throw (response.error);
        }
        dispatch(loginSuccess(getLoginData()));
        if (callback && callback.onSuccess) callback.onSuccess(response);
        return response;
      })
      .catch((error) => {
        dispatch(logout(error));
        if (callback && callback.onError) callback.onError(error);
        // throw error;
      });
  };
}
